import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "k-popup__header text-center flex column items-center justify-center" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "k-popup__actions q-pt-lg flex items-center justify-center"
}

import { reactive, watchEffect } from 'vue'

interface IProps {
  modelValue?: boolean
  icon?: string
  iconColor?: string
  iconSize?: string
  text?: string
  description?: string
  contentClass?: string | Record<string, boolean> | (string | Record<string, boolean>)[]
  wrapperClass?: string | Record<string, boolean> | (string | Record<string, boolean>)[]
  popupClass?: string | Record<string, boolean> | (string | Record<string, boolean>)[]
  maxWidth?: string
}

interface IEmits {
  (event: 'update:modelValue', data: boolean): void
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KPopup' },
  __name: 'KPopup',
  props: {
    modelValue: { type: Boolean, default: false },
    icon: { default: '' },
    iconColor: { default: '' },
    iconSize: { default: '48px' },
    text: { default: '' },
    description: { default: '' },
    contentClass: { default: 'bg-white q-py-xl q-px-md' },
    wrapperClass: { default: '' },
    popupClass: { default: '' },
    maxWidth: { default: '552px' }
  },
  emits: ["update:modelValue"],
  setup(__props: any) {



const props = __props


const state = reactive({ modelValue: props.modelValue })

watchEffect(() => {
  state.modelValue = props.modelValue
})

return (_ctx: any,_cache: any) => {
  const _component_KIcon = _resolveComponent("KIcon")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: state.modelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.modelValue) = $event)),
    class: "Popup",
    onHide: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', state.modelValue)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["Popup__wrapper full-width shadow-3 hide-scrollbar", __props.wrapperClass]),
        style: _normalizeStyle(`--max-width: ${__props.maxWidth}`)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["k-popup rounded-48 q-pa-lg", __props.popupClass])
        }, [
          _renderSlot(_ctx.$slots, "header"),
          _createElementVNode("div", {
            class: _normalizeClass(["k-popup__content rounded-32 q-py-xl q-px-md", __props.contentClass])
          }, [
            _createElementVNode("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "icon", {}, () => [
                (__props.icon)
                  ? (_openBlock(), _createBlock(_component_KIcon, {
                      key: 0,
                      class: "k-popup__icon q-mb-lg",
                      name: __props.icon,
                      color: __props.iconColor,
                      size: __props.iconSize
                    }, null, 8, ["name", "color", "size"]))
                  : _createCommentVNode("", true)
              ]),
              (__props.text)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "k-popup__text text-cool-gray-100 fs-19px fw-600 q-mb-lg",
                    innerHTML: __props.text
                  }, null, 8, _hoisted_2))
                : _createCommentVNode("", true),
              (__props.description)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "k-popup__description text-cool-gray-80 fs-15px fw-400 q-mb-lg",
                    innerHTML: __props.description
                  }, null, 8, _hoisted_3))
                : _createCommentVNode("", true)
            ]),
            _renderSlot(_ctx.$slots, "default"),
            (_ctx.$slots['actions'])
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _renderSlot(_ctx.$slots, "actions")
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ], 2)
      ], 6)
    ]),
    _: 3
  }, 8, ["modelValue"]))
}
}

})